module.exports = __webpack_public_path__ + "static/img/wx_icon.304d5949.png";